import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LangProvider } from "@/context/LangContext";
import { Toaster } from "@/components/ui/sonner";
import WeddingHome from "@/pages/WeddingHome";
import AdminPage from "@/pages/AdminPage";

function App() {
  return (
    <LangProvider>
      <div className="App parchment-bg min-h-screen">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<WeddingHome />} />
            <Route path="/admin" element={<AdminPage />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </div>
    </LangProvider>
  );
}

export default App;
